// JavaScript Document

var keydown_timeout;
var keydown_xhr;

function searchForm() {
	"use strict";
    $('form[name="search-form"] input').on('keydown',function(e){
        switch(true){
            case e.keyCode === 13: // ENTER
                if($('.quick-jump a.active').length>0){
                    var param = $('.quick-jump a.active').attr('href');
                    registerGAEvent('Search Form','submit',param);
                    window.location = param;
                    return false;
                }
                break;
        }
    });

    $('form[name="search-form"] input').on('keyup',function(e){

        switch(true){
            case e.keyCode === 38: // UP
                if($('.quick-jump a').length>0){
                    if($('.quick-jump a.active').length>0){
                        $('.quick-jump a.active').prev().addClass('active');
                        $('.quick-jump a.active:last').removeClass('active');
                    }else{
                        $('.quick-jump a:last').addClass('active');
                    }
                }
                break;
            case e.keyCode === 40: // DOWN
                if($('.quick-jump a').length>0){
                    if($('.quick-jump a.active').length>0){
                        $('.quick-jump a.active').next().addClass('active');
                        $('.quick-jump a.active:first').removeClass('active');
                    }else{
                        $('.quick-jump a:first').addClass('active');
                    }
                }
                break;
            default:
                var search_param = $('form[name="search-form"] input[name="q"]').val();

                if(search_param.length>3){

                    if(keydown_xhr!==null){
                        keydown_xhr.abort();
                        clearTimeout(keydown_timeout);
                    }

                    keydown_timeout = setTimeout(function(){

                        keydown_xhr = $.ajax({data: {
                            module:'products',
                            action:'get-search-keywords',
                            search_param :search_param
                        }, success: function (data) {
                            var m = [];
                            for(var i in data){
                                var u = URL + 'search-results/?q='+data[i]['text'];
                                m.push('<a href="'+u+'" class="list-group-item">'+data[i]['text']+'</a>');
                            }
                            $('.quick-jump').html(m.join(''));
                        }});
                    },200);
                }else{
                    $('.quick-jump').empty();
                }
        }
    });
    $('form[name="search-form"]').validate({

        submitHandler: function () {



            if(keydown_xhr!==null){
                keydown_xhr.abort();
                clearTimeout(keydown_timeout);
            }

            var search_param =$('form[name="search-form"] input[name="q"]').val();

            $('.quick-jump').empty();

            registerGAEvent('Search Form','submit',search_param);

            window.location=URL + 'search-results/?q='+search_param;
            return false;
        }
    });
}


function contactForm() {
	"use strict";
	
	
	 var uploader = new plupload.Uploader({
        runtimes : 'html5,flash,silverlight,html4',

        browse_button : 'pickfiles',
        container: document.getElementById('upload-container'),

        url : "/?module=medialibrary&action=upload",

        filters : {
            max_file_size : '7000kb',
            mime_types: [
                {title : "Documents", extensions : "pdf,doc,docx,txt,rtf"}
            ]
        },

        multi_selection:false,
        unique_names:true,
        init: {
            PostInit: function() {
                document.getElementById('filelist').innerHTML = '';
                 if($('input[type="file"]').length){
                    $('input[type="file"]').prepend('<label class="visually-hidden" for="'+$('input[type="file"]').attr('id')+'">Files</label>')
                }

            },

            FilesAdded: function(up, files) {

                plupload.each(files, function(file) {
                    document.getElementById('filelist').innerHTML = '<div id="' + file.id + '">' + file.name + ' (' + plupload.formatSize(file.size) + ') <b></b></div>';
                });
                uploader.start();
            },

            UploadProgress: function(up, file) {
                document.getElementById(file.id).getElementsByTagName('b')[0].innerHTML = '<span>' + file.percent + "%</span>";
            },
            FileUploaded: function(up, file) {
                document.getElementById(file.id).getElementsByTagName('b')[0].innerHTML += '<input type="hidden" name="cv_file" value="' + file.target_name + '"/>';
            },
            Error: function(up, err) {
                document.getElementById('filelist').innerHTML = "\nError #" + err.code + ": " + err.message;
            }
        }
    });

    uploader.init();
	


    $('form[name="contact-form"]').validate({

        submitHandler: function () {

              if (typeof (grecaptcha) !== 'undefined') {
                grecaptcha.ready(function () {
                    grecaptcha.execute(RECAPTCHA_KEY, { action: 'submit' }).then(function (token) {
                     $('form[name="contact-form"]').append('<input class="gr-recaptcha" name="g-recaptcha-response" type="hidden" value="'+token+'"/>');
                        var submitButton = $('form[name="contact-form"] button[type="submit"]');
                        submitButton.attr('disabled','disabled');

                        $.ajax({data: $('form[name="contact-form"]').serialize(), success: function (data) {
                            if (data.status == 'ok') {

                                form_submit_response('form[name="contact-form"]', 'success', data.message, true);
            					
                                submitButton.removeAttr('disabled');
                                 if($('form[name="contact-form"]').find('.gr-recaptcha').length>0 ){
                                    $('form[name="contact-form"]').find('.gr-recaptcha').remove();
                                }
                                if(typeof(ga)!=='undefined'){
                                    ga('send', 'pageview', '/contact-success.html');
                                }
                                

            					setTimeout(function () {
            						window.location.reload();
            					}, 2000);
            					
                            } else if (data.status == 'error') {

                                 submitButton.removeAttr('disabled');
                                 if($('form[name="contact-form"]').find('.gr-recaptcha').length>0 ){
                                    $('form[name="contact-form"]').find('.gr-recaptcha').remove();
                                }

                                form_submit_response('form[name="contact-form"]', 'error', data.error);
                            } else {

                                 submitButton.removeAttr('disabled');
                                 if($('form[name="contact-form"]').find('.gr-recaptcha').length>0 ){
                                    $('form[name="contact-form"]').find('.gr-recaptcha').remove();
                                }

                                form_submit_response('form[name="contact-form"]', 'error', 'An unknown error occurred. Please try again later');
                            }
                        }});

                    });
                });
            }
        }
    });
}


function scaleCaptcha() {
	"use strict";
	var reCaptchaWidth = $('.g-recaptcha').innerWidth();		
	var containerWidth = $('.container').width();
	if(reCaptchaWidth > containerWidth) {		
		var captchaScale = containerWidth / reCaptchaWidth;
		$('.g-recaptcha').css({
			'transform':'scale('+captchaScale+')'
		});
	}
}

function debug(msg,append){
	"use strict";
    if($body.find('#debugger').length === 0){
        $body.prepend(
            '<div id="debugger" class="card blue-grey darken-1" style="position: fixed;z-index:9999;top:10px;left:10px;right:10px;max-height:200px;overflow: auto">' +
                '<a href="#" onclick="$(\'#debugger\').remove();return false;" style="position: absolute;z-index:999;top:10px;right:10px;overflow: auto"><i class="fa fa-times"></i></a>' +
                '<div class="card-content"></div>' +
                '</div>'
        );
    }

    if(append){
        $('#debugger .card-content').append('<p>'+JSON.stringify(msg)+'</p>');
    }else{
        $('#debugger .card-content').html('<p>'+JSON.stringify(msg)+'</p>');
    }


}
function parseQuery(str){
	"use strict";
    if(typeof str !== "string" || str.length === 0) {
		return {};
	}
    var s = str.split("&");
    var s_length = s.length;
    var bit, query = {}, first, second;
    for(var i = 0; i < s_length; i++)
    {
        bit = s[i].split("=");
        first = decodeURIComponent(bit[0]);
        if(first.length === 0){continue;} 
        second = decodeURIComponent(bit[1]);
        if(typeof query[first] === "undefined") {
			query[first] = second;
		}else if(query[first] instanceof Array) {
			query[first].push(second);
		}else {
			query[first] = [query[first], second];
		}
    }
    return query;
}



function getHash() {
	"use strict";
    var hash = window.location.hash;
    return hash.substring(2); // remove #!
}


function form_submit_response(target, type, message, r) {
	"use strict";
    /*var redirect = r || false;
    $('#growls').empty();
    if (type == 'error') {
        $.growl.error({ duration:6000,title:'',message: message, location: 'tr',size:'large'  });
    } else if (type == 'warning') {
        $.growl.warning({ duration:6000,title:'',message: message, location: 'tr',size:'large'   });
    } else if (type == 'success') {
        $.growl.notice({ duration:6000,title: '', message: message, location: 'tr',size:'large'  });
    } else {
        $.growl({duration:6000,title: '', message: message, location: 'tr',size:'large'  });
    }
    if (redirect) {
        setTimeout(function () {
            window.location.reload();
        }, 2000);
    }*/
	alert(message);
}

function initNewsletterForm() {
	"use strict";
	$('form[name="newsletter-form"] #newsletter_reg').click(function(){
		var this_ckeckbox = $(this);
		if(this_ckeckbox.hasClass('checked')){
			this_ckeckbox.removeClass('checked');
			this_ckeckbox.removeAttr('checked');			
			$('form[name="newsletter-form"] input[name="newsletter"]').attr('value', '0');
		}else{
			this_ckeckbox.attr('checked','checked');
			this_ckeckbox.addClass('checked');
			$('form[name="newsletter-form"] input[name="newsletter"]').attr('value', '1');
		}
	});
    $('form[name="newsletter-form"]').validate({
        submitHandler: function () {

            if (typeof (grecaptcha) !== 'undefined') {
                grecaptcha.ready(function () {
                    grecaptcha.execute(RECAPTCHA_KEY, { action: 'submit' }).then(function (token) {
                     $('form[name="newsletter-form"]').append('<input class="gr-recaptcha" name="g-recaptcha-response" type="hidden" value="'+token+'"/>');
                        var submitButton = $('form[name="newsletter-form"] button[type="submit"]');
                        submitButton.attr('disabled','disabled');

                         $.ajax({data: $('form[name="newsletter-form"]').serialize(), success: function (data) {
                            if (data.status === "ok") {
                               form_submit_response('form[name="newsletter-form"]', 'success', data.message);


                                submitButton.removeAttr('disabled');
                                 if($('form[name="newsletter-form"]').find('.gr-recaptcha').length>0 ){
                                    $('form[name="newsletter-form"]').find('.gr-recaptcha').remove();
                                }

                                $('form[name="newsletter-form"]')[0].reset();

                            } else if (data.status === 'error') {
                                form_submit_response('form[name="newsletter-form"]', 'error', data.error);

                                 submitButton.removeAttr('disabled');
                                 if($('form[name="newsletter-form"]').find('.gr-recaptcha').length>0 ){
                                    $('form[name="newsletter-form"]').find('.gr-recaptcha').remove();
                                }
                            } else {
                                form_submit_response('form[name="newsletter-form"]', 'error', 'An unknown error occurred. Please try again later');

                                 submitButton.removeAttr('disabled');
                                 if($('form[name="newsletter-form"]').find('.gr-recaptcha').length>0 ){
                                    $('form[name="newsletter-form"]').find('.gr-recaptcha').remove();
                                }
                            }
                        }});
                  });
                });
            }

           
        }
    });
}

$(function(){
	"use strict";
    $.validator.setDefaults({
        debug: false,
        errorPlacement: function(error) {
            error.hide();
        },
        highlight: function (element, errorClass, validClass) {

            if($(element).is(':radio')){
                $(element).parent().parent().find('.form-control-feedback').remove();
                $(element).parent().parent().append('<span class=" form-control-feedback" style="right:-20px"><i class="fa fa-times"></i></span>');
                $(element).parent().parent().addClass('has-error has-feedback');
            }else{
                $(element).addClass('invalid').removeClass('valid');
            }

        },
        unhighlight: function (element, errorClass, validClass) {
            $(element).removeClass('invalid').addClass('valid');
        }
    });
});
